
// @ts-ignore
import JpgIcon from '@/assets/common_images/jpg.png'
// @ts-ignore
import PdfIcon from '@/assets/common_images/pdf.png'
// @ts-ignore
import WordIcon from '@/assets/common_images/word.png'
import { withApiHost } from '@/common/utils'

export type IFileType = 'word' | 'pdf' | 'photo'

export interface IFile {
    name: string
    link: string
    type: IFileType
}

function formatAnnexes(annexes: any[]) {
    if (!annexes.length) return []
    const fileList = annexes.map((file: IFile) => {
        const tail = file.name.substr(file.name.lastIndexOf('.') + 1).toUpperCase()
        let type: IFileType = 'pdf'
        const word = ['DOC', 'DOCX']
        const photo = ['JPG', 'JPEG', 'PNG']
        if (word.indexOf(tail) !== -1) {
            type = 'word'
        } else if (photo.indexOf(tail) !== -1) {
            type = 'photo'
        }
        file.type = type
        return file
    })
    return fileList
}

/**
 * @prop 
*/
export default {
    functional: true,
    props: {
        list: {
            type: Array,
            required: true
        }
    },
    render(h: any, ctx: any) {
        const { list } = ctx.props

        const annexes = formatAnnexes(list)

        const onPreviewFile = ({ type, link }: IFile) => {
            // S3 附件 link 为相对路径 /v1/img?key=...，必须补全 API 域名，
            // 否则 window.open 打到前端域名被 SPA fallback 成 index.html
            const fullLink = withApiHost(link)
            let src
            if (type === 'word') {
                const mircoOfficeTool = 'https://view.officeapps.live.com/op/view.aspx?src='
                src = mircoOfficeTool + encodeURIComponent(fullLink)
            } else {
                src = fullLink
            }
            window.open(src, '_blank')
        }

        return (
            <ul class="file-list" i-class="overflow-hidden">
                {
                    annexes.map((file: any) => (
                        <li class="file-item" 
                            i-class="br-4 flex align-middle"
                            onClick={() => onPreviewFile(file)}
                            key={file.name}>
                            { 
                                file.type === 'photo' ? (
                                    <img class="file-icon photo" src={JpgIcon} alt="png" />
                                ) : file.type === 'pdf' ? (
                                    <img class="file-icon" src={PdfIcon} alt="pdf" />
                                ) : (
                                    <img class="file-icon" src={WordIcon} alt="png" />
                                )
                            }
                            <span class="file-name" i-class="text-black ml-10">{ file.name }</span>
                        </li>        
                    ))
                }
            </ul>
        )
    }
}
